import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {



    constructor(private router:Router){}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('t');

    const authReq = token
      ? req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
      : req;

      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {

         let mensajeError = "Error de autenticaci&oacute;n. Por favor reinicie la sesi&oacute;n";
         let logout = false;

         switch (error.status) {
            case 401:
            case 403:
            case 419:
            case 498:
            case 429:
                logout = true;

                if (error.error.mensaje) {
                    mensajeError = error.error.mensaje;
                }

                break;
            default:
                break;
         }

         if (logout) {
          sessionStorage.clear(); 
          localStorage.removeItem('cuenta');
          localStorage.removeItem('usuario');
          localStorage.removeItem('nombre');
          localStorage.removeItem('nro_cliente');
          localStorage.removeItem('nro_proveedor');
          localStorage.removeItem('razon');
          this.router.navigate(['/login']);
        }


        return throwError(() => ({
          status: error.status,
          message: mensajeError,
          originalError: error,
        }));

        })
      );
  }
}
